import React, { useEffect, useState } from 'react';
import CrossGray from '../../../../Assets/StorefrontIcons/CrossGray.svg';
import { useDispatch } from 'react-redux';
import { setSectionFormType, setSectionType } from '../../../../Features/storefrontSlice';
import { v4 as uuidv4 } from 'uuid';
import CrossSmall from '../../../../Assets/CrossSmall.svg';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { addStorefrontSEO, getStorefrontSEOData, updateStorefrontSEO } from '../../../../lib/utils/apiCalls';

function SEOForm() {
    const dispatch = useDispatch();

    const defaultFormFields = {
        metaTitle: '',
        metaDescription: ''
    };

    const defaultFormErrors = {
        metaTitle: '',
        metaDescription: '',
        metaKeywords: '',
    };

    const [responseHasSEO, setResponseHasSEO] = useState(false);

    const [formInputs, setFormInputs] = useState(defaultFormFields);
    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const [keywordValue, setKeywordValue] = useState('');
    const [keywords, setKeywords] = useState([]);

    function handleKeywordChange(e) {
        setKeywordValue(e.target.value);
    }

    function handleKeyDown(e) {
        if(e.key === 'Enter') {
            if(keywords.some(obj => obj.keyword === keywordValue)) {
                showToast('Keyword already present!', 'warning');
            }
            else {
                setKeywords(prev => [...prev, { keyword: keywordValue, id: uuidv4() }]);
                setKeywordValue('');
            }
        }
    }

    function removeKeyword(id) {
        const filteredList = keywords.filter(keyword => keyword.id !== id);
        setKeywords(filteredList);
    }

    function handleChange(e) {
        const { name, value } = e.target;
        setFormInputs({ ...formInputs, [name]: value });
    }

    function handleClose() {
        dispatch(setSectionType(null));
        dispatch(setSectionFormType(null));
    }

    async function handleSave() {
        const validationErrors = {};

        if(!formInputs.metaTitle) {
            validationErrors.metaTitle = 'Required field';
        }

        if(!formInputs.metaDescription) {
            validationErrors.metaDescription = 'Required field';
        }

        if(keywords.length === 0) {
            validationErrors.metaKeywords = 'Keywords required';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormErrors);

            const callBody = {
                MetaTitle: formInputs.metaTitle,
                MetaDescription: formInputs.metaDescription,
                KeyWords: keywords.map(item => item.keyword),
            }

            try {
                if(responseHasSEO) {
                    const response = await updateStorefrontSEO(callBody);
                    if(response.status === 200) {
                        showToast('SEO updated!', 'success');
                    }
                }
                else {
                    const response = await addStorefrontSEO(callBody);
                    if(response.status === 200) {
                        showToast('SEO added!', 'success');
                    }
                }
            }
            catch(err) {
                console.log(err);
            }
            handleClose();
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    useEffect(() => {
        async function fetchStoreSEO() {
            try {
                const response = await getStorefrontSEOData();

                if(response.status === 200) {
                    if(response?.data?.data?.length > 0 || Object.keys(response?.data?.data)?.length > 0) {
                        setResponseHasSEO(true);

                        const {
                            MetaDescription,
                            MetaTitle,
                            KeyWords,
                        } = response.data.data;

                        setFormInputs({
                            metaTitle: MetaTitle,
                            metaDescription: MetaDescription,
                        });

                        if(KeyWords) {
                            setKeywords(KeyWords.map(item => {
                                return (
                                    {
                                        keyword: item,
                                        id: uuidv4(),
                                    }
                                )
                            }));
                        }
                    }
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        fetchStoreSEO();
    }, []);

    return (
        <div className='w-[400px] border-r border-[#EAEAEA] flex flex-col gap-4 select-none relative'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>SEO</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={handleClose} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col gap-3 px-3 overflow-y-scroll no-scrollbar pb-16">
                <p className='font-medium text-[14px] leading-6 text-[#121212]'>Page: Store and deals</p>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label htmlFor="metaTitle" className='font-medium text-base text-[#121212]'>Meta title</label>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.metaTitle}</p>
                    </div>

                    <input 
                        id='metaTitle' 
                        name='metaTitle' 
                        className='outline-none border text-base border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] text-[#121212] placeholder:text-[#666666]' 
                        placeholder='Enter meta title' 
                        type="text" 
                        value={formInputs.metaTitle} 
                        onChange={handleChange} 
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label htmlFor="metaDescription" className='font-medium text-base text-[#121212]'>Meta description</label>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.metaDescription}</p>
                    </div>

                    <textarea 
                        className='outline-none border h-36 text-base border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-[9px] text-[#121212] placeholder:text-[#666666]' 
                        name="metaDescription" 
                        id="metaDescription" 
                        placeholder='Write meta description' 
                        value={formInputs.metaDescription} 
                        onChange={handleChange} 
                    />
                </div>

                <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between">
                        <label htmlFor="meta-keywords" className='font-medium text-base text-[#121212]'>Keywords</label>

                        <p className='text-[12px] leading-5 text-[#EF4444]'>{formErrors.metaKeywords}</p>
                    </div>

                    <div className="border h-36 text-base border-[#EAEAEA] px-3 py-4 rounded-[9px] bg-[#F5F5F5] flex gap-2 flex-wrap">
                        {keywords?.map(keyword => {
                            return (
                                <div key={keyword.id} className="w-fit h-fit border border-[#EAEAEA] bg-[#FFFFFF] rounded px-2 py-1 flex items-center">
                                    <p className='font-normal text-[14px] leading-6 text-[#121212]'>{keyword.keyword}</p>

                                    <button onClick={() => removeKeyword(keyword.id)} className="w-4 h-4 p-[3px] flex items-center justify-center">
                                        <img src={CrossSmall} alt="" />
                                    </button>
                                </div>
                            )
                        })}

                        {
                            keywords.length < 5 && 
                            <input 
                                className='py-1 flex-grow h-fit font-normal outline-none text-base bg-transparent text-[#121212] placeholder:text-[#888888]' 
                                type="text" 
                                placeholder='Max 5 keywords, add keyword and hit enter' 
                                id='meta-keywords' 
                                name='meta-keywords' 
                                value={keywordValue} 
                                onChange={handleKeywordChange} 
                                onKeyDown={handleKeyDown} 
                            />
                        }
                    </div>
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full p-3 bg-[#FFFFFF]">
                <button onClick={handleSave} className='w-full outline-none px-4 py-[6px] bg-primaryColor hover:bg-primaryAccent rounded-md font-semibold text-[12px] leading-6 text-buttonText'>Save changes</button>
            </div>
        </div>
    );
}

export default SEOForm;
